<script lang="tsx">
import {
  defineComponent, type PropType, type ComputedRef, computed,
} from 'vue'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'

export default defineComponent({
  props: {
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },

    onSort: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props) {
    const isAscOrder: ComputedRef<boolean> = computed(() => props.column.sort === props.sortField && props.sortOrder === true)
    const isDescOrder: ComputedRef<boolean> = computed(() => props.column.sort === props.sortField && props.sortOrder === false)

    const onSort = (e: Event) => {
      e.stopPropagation()

      if (props.onSort) props.onSort()
    }

    return () => (

      <button class="ark-ui-table-header-sort" onClick={onSort}>
        <svg class={isAscOrder.value ? 'ark-ui-table-header-sort-hidden' : ''} width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* eslint-disable-next-line max-len */}
          <path class={`${isDescOrder.value ? 'active' : ''}`} fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 0C3.6484 0 3.78913 0.0659115 3.88412 0.179908L6.38412 3.17991C6.56091 3.39205 6.53224 3.70733 6.3201 3.88411C6.10797 4.06089 5.79268 4.03223 5.6159 3.82009L4.00001 1.88102V11.5C4.00001 11.7761 3.77615 12 3.50001 12C3.22387 12 3.00001 11.7761 3.00001 11.5V1.88102L1.38412 3.82009C1.20734 4.03223 0.892059 4.06089 0.67992 3.88411C0.467782 3.70733 0.43912 3.39205 0.615902 3.17991L3.1159 0.179908C3.2109 0.0659115 3.35162 0 3.50001 0Z" />
        </svg>

        <svg class={isDescOrder.value ? 'ark-ui-table-header-sort-hidden' : ''} width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* eslint-disable-next-line max-len */}
          <path class={`${isAscOrder.value ? 'active' : ''}`} fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 0C3.6484 0 3.78913 0.0659115 3.88412 0.179908L6.38412 3.17991C6.56091 3.39205 6.53224 3.70733 6.3201 3.88411C6.10797 4.06089 5.79268 4.03223 5.6159 3.82009L4.00001 1.88102V11.5C4.00001 11.7761 3.77615 12 3.50001 12C3.22387 12 3.00001 11.7761 3.00001 11.5V1.88102L1.38412 3.82009C1.20734 4.03223 0.892059 4.06089 0.67992 3.88411C0.467782 3.70733 0.43912 3.39205 0.615902 3.17991L3.1159 0.179908C3.2109 0.0659115 3.35162 0 3.50001 0Z" />
        </svg>
      </button>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-header-sort {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  background: transparent;
  width: 24px;
  min-width: 24px;
  height: 24px;
  border-radius: 2px;
  padding: 0;

  &-hidden {
    display: none;
  }

  path {
    fill: #A3A7B9;

    &.active {
      fill: #30C1CF !important;
    }
  }

  > *:first-child {
    transform: rotate(180deg);
  }

  &:hover {
    background-color: #D3D5E5;
    path {
      fill: #585B69;
    }
  }
}
</style>
